import React from 'react';
import { Card } from '../core/Card.jsx';
import { Statistic } from './Statistic.jsx';

export function StatCard({ variant, footer, actions, ...statProps }) {
  const resolved = variant || (statProps.state === 'placeholder' ? 'placeholder' : statProps.tone === 'signal' ? 'signal' : 'default');
  return (
    <Card variant={resolved} pad="md" footer={footer} actions={actions}>
      <Statistic {...statProps} />
    </Card>
  );
}
